import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChildren, OnChanges, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { take } from 'rxjs/operators';
import { DocumentoModel } from 'src/app/core/models/documento.model';
import { ImagenDocumentoModel } from 'src/app/core/models/imagen-documento.model';
import { TipoDocumentoModel } from 'src/app/core/models/tipo-documento.model';
import { DocumentoService } from 'src/app/core/services/documento.service';
import { DistintivoAmbientalService } from 'src/app/core/services/maestras/distintivo-ambiental.service';
import { SectorService } from 'src/app/core/services/maestras/sector.service';
import { TipoCombustibleService } from 'src/app/core/services/maestras/tipo-combustible.service';
import { TipoDocumentoService } from 'src/app/core/services/maestras/tipo-documento.service';
import { TipoPlazaService } from 'src/app/core/services/maestras/tipo-plaza.service';
import { TipoVehiculoService } from 'src/app/core/services/maestras/tipo-vehiculo.service';
import { UsoVehiculoService } from 'src/app/core/services/maestras/uso-vehiculo.service';
import { BaseComponent } from 'src/app/pages/area-privada/components/base/base.component';
import { environment } from 'src/environments/environment';
import { VehiculoModel } from '../../../../../../core/models/vehiculo.model';

@Component({
  selector: 'dum-registro-documentacion-vehiculo',
  templateUrl: './registro-documentacion-vehiculo.component.html',
  styleUrls: ['./registro-documentacion-vehiculo.component.scss']
})
export class RegistroDocumentacionVehiculoComponent extends BaseComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChildren('formNewDocumentoVehiculo') formNewDocumento: NgForm;

  @Input() documentos: DocumentoModel[] = []; // ARRAY PRINCIPAL

  @Input() newDocumentos: File[] = [];

  @Input() isVehiculoMenor12TN: boolean;

  @Input() isAllDocuments: boolean;

  selectTiposDocumentos: TipoDocumentoModel[];
  acceptTypeDocument: string;

  documentoAnadir: DocumentoModel;

  newImagen: File[] = []; // IMAGENES DE LOS ARCHIVOS
  tipoDocumento: TipoDocumentoModel; // AQUI SE ASIGNA EL TIPO DE DOCUMENTO
  fechaVencimientoNewDocumento: Date = undefined; // AQUI SE PONE LA FECHA DE VENCIMIENTO DEL TIPO
  mostrarAnterior: boolean = true;
  visibleAddDocumento: boolean = false;
  tipoDocumentoNewDocumento: TipoDocumentoModel;
  localeCalendar: any;
  minDate: Date = new Date();
  vehiculoMenor12TN: boolean;
  mostrarArchivos: boolean = true;


  @Output() eventSiguienteDocumentos: EventEmitter<DocumentoModel[]> = new EventEmitter<DocumentoModel[]>();

  @Output() eventSiguienteArchivos: EventEmitter<File[]> = new EventEmitter<File[]>();

  @Output() eventAnteriorToVehiculo: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() eventEmitIsAllDocuments: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(
    protected tipoVehiculoService: TipoVehiculoService,
    protected tipoCombustibleService: TipoCombustibleService,
    protected usosVehiculosServices: UsoVehiculoService,
    protected sectoresService: SectorService,
    protected distintivosAmbientalesServices: DistintivoAmbientalService,
    protected clasificacionVehiculoService: TipoPlazaService,
    protected tipoDocumentoService: TipoDocumentoService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private documentoService: DocumentoService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService
  ) {
    super(
      sectoresService,
      tipoVehiculoService,
      tipoCombustibleService,
      usosVehiculosServices,
      distintivosAmbientalesServices,
      clasificacionVehiculoService,
      tipoDocumentoService,
    );
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.vehiculoMenor12TN = changes.isVehiculoMenor12TN.currentValue;
  }
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
  initData() {
    // Obtención tipos clasificacion de los vehículos
    this.getClasificacionVehiculos();
    // Obtención de los distintivos ambientales.
    this.getDistintivosAmbientales();
    // Obtención de todos los sectores.
    this.getSectores();
    // Obtención de los usos de vehiculos existentes.
    this.getUsosVehiculos();
    // Obtención de los tipos de combustibles.
    this.getTipoCombustible();
    // Obtención de los tipos de vehículos.
    this.getTipoVehiculo();
    // Obtención tipos de documentos
    this.getTiposDocumentos();
  }


  ngOnInit(): void {
    this.acceptTypeDocument = environment.accepts_type_documents;
    this.initData();
    this.localeCalendar = environment.calendar_locale.es;
    this.validateDocuments();
  }

  // Es el primero que sale
  addDocumento() {
    this.selectTiposDocumentos = this.tiposDocumentos.filter((tipo) => {
      let existTipo = false;
      this.documentos.forEach((documento) => {
        if (tipo.id === documento.tipoDocumento.id) {
          existTipo = true;
        }
      });
      return !existTipo;
    });
    if (this.selectTiposDocumentos.length > 0) {
      this.visibleAddDocumento = true;
      this.cd.detectChanges();
    } else {
      this.dumToast.add({ severity: 'error', summary: this.translateService.instant('GLOBAL.DOCUMENTOS'), detail: `${this.translateService.instant('DOCUMENTOS.MSG.MAX.AÑADIDO')}` });
    }
  }

  addNewDocumento(event) {
    this.newDocumentos[this.tipoDocumentoNewDocumento.nombre] = event.currentFiles;
    this.newDocumentos.push(event.currentFiles);
  }

  deleteNewDocumento(event) {
    this.newDocumentos.splice(this.newDocumentos.indexOf(event.file), 1);
    this.newDocumentos[this.tipoDocumentoNewDocumento.nombre].forEach((file: File, key) => {
      if (file.name === event.file.name) {
        this.newDocumentos[this.tipoDocumentoNewDocumento.nombre].splice(key, 1);
      }
    });

  }

  cancelNewDocumento() {
    this.visibleAddDocumento = false;
    this.fechaVencimientoNewDocumento = undefined;
    this.tipoDocumentoNewDocumento = undefined;
  }

  saveNewDocumento() {
    const documentoAnadir: DocumentoModel = new DocumentoModel();
    const fechaVencimiento = this.fechaVencimientoNewDocumento !== undefined ? `${this.fechaVencimientoNewDocumento.getDate()}/${this.fechaVencimientoNewDocumento.getMonth() + 1}/${this.fechaVencimientoNewDocumento.getUTCFullYear()}` : undefined;

    documentoAnadir.fechaVencimiento = fechaVencimiento;
    documentoAnadir.tipoDocumento = this.tipoDocumentoNewDocumento;

    this.newDocumentos[this.tipoDocumentoNewDocumento.nombre].forEach((file) => {
      const imagenAux: ImagenDocumentoModel = new ImagenDocumentoModel();
      imagenAux.nombre = file.name.toString();
      imagenAux.file = file;
      documentoAnadir.imagen.push(imagenAux);
    });

    this.documentos.push(documentoAnadir);
    this.visibleAddDocumento = false;
    this.validateDocuments();

    // Reinicio variables

    this.fechaVencimientoNewDocumento = undefined;
    this.tipoDocumentoNewDocumento = undefined;
  }

  validateDocuments() {
    const hasImpTracMecanica = !!this.documentos.find((doc : DocumentoModel) => doc.tipoDocumento.id === 3);
    const hasPermCirculacion = !!this.documentos.find((doc : DocumentoModel) => doc.tipoDocumento.id === 2);
    const hasPermFichaTecnica = !!this.documentos.find((doc : DocumentoModel) => doc.tipoDocumento.id === 1);
    const hasTarjetaTransporte = !!this.documentos.find((doc : DocumentoModel) => doc.tipoDocumento.id === 4);
    this.isAllDocuments = (this.vehiculoMenor12TN) ? hasImpTracMecanica && hasPermCirculacion && hasPermFichaTecnica && hasTarjetaTransporte :
                                                     hasImpTracMecanica && hasPermCirculacion && hasPermFichaTecnica;
  }

  downloadDocument(imagen: ImagenDocumentoModel) {
    if (imagen.id) {
      this.documentoService.getImagenesDocumentos(imagen.id)
      .pipe(take(1))
      .subscribe((img) => {
        const fileUrl = window.URL.createObjectURL(img);
        if ((window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(img, imagen.nombre);
        } else {
          window.open(fileUrl);
        }
      });
    } else if (imagen.file) {
      const fileUrl = window.URL.createObjectURL(imagen.file);
      if ((window.navigator as any).msSaveOrOpenBlob) {
        (window.navigator as any).msSaveOrOpenBlob(imagen.file, imagen.nombre);
      } else {
        window.open(fileUrl);
      }
    }
  }

  deleteDocumento(documento: DocumentoModel) {
    this.confirmationService.confirm(
      {
        acceptLabel: this.translateService.instant('GLOBAL.SI'),
        rejectLabel: this.translateService.instant('GLOBAL.NO'),
        message: `${this.translateService.instant('DOCUMENTO.MSG.CONFIRMACION.ELIMINAR')} ${documento.tipoDocumento.nombre}`,
        accept: () => {
          this.documentos.splice(this.documentos.indexOf(documento), 1);
          this.validateDocuments();
        }
      });
  }

  resetearVariables() {
    this.newDocumentos[this.tipoDocumentoNewDocumento.nombre] = [];
    this.fechaVencimientoNewDocumento = undefined;
    this.mostrarArchivos = false;
    this.cd.detectChanges();
    this.mostrarArchivos = true;
    this.cd.detectChanges();
  }


  // Poner la ubicacion de la pagina principal
  volver() {
    this.eventAnteriorToVehiculo.emit(this.mostrarAnterior);
  }

  // Registro de una persona normal en la web
  finalizar() {
    this.eventSiguienteDocumentos.emit(this.documentos);
    this.eventSiguienteArchivos.emit(this.newDocumentos);
    this.eventEmitIsAllDocuments.emit(this.isAllDocuments);
  }

}
